/**
 * Created by Ivan on 07.07.2026
 */

const StickersRewardWindow = function (isFirstReward) {
    const stickers = cleverapps.stickersBook.newStickers;
    cleverapps.stickersBook.newStickers = undefined;

    const WindowFactory = Prefab.createWindow("stickers_reward_window", "stickers_reward_window_prefab_json", {
        bundles: () => cleverapps.unique(stickers.map((sticker) => SeasonCollectionsHelper.getCollectionBundleName(sticker.collection.index, sticker.collection.season)))
    });

    return new WindowFactory(isFirstReward, stickers);
};
